/**
 * Enum for terminal vendors.
 * @readonly
 * @enum {String} TerminalVendorEnum
 */

const TerminalVendorEnum = {
  VIVA  : 'viva',
  MELLON: 'mellon_group',
  EPAY  : 'epay',
  EDPS  : 'edps',
  NEXI  : 'nexi'
}

export default TerminalVendorEnum
